import { DEFAULT_TIME_FORMAT, TIME_FORMATS } from '../enums';
import { store } from "../store/store";

const prependZero = (value: number) => {
    if (value.toString().length == 1) {
        return '0' + value;
    }
    return value;
}
export const getTimeStamp = (payload: Date) => {
    const todayDate = new Date();
    const timeFormat = store.state.pageConfig.messageTimeFormat || DEFAULT_TIME_FORMAT;
    let formattedDate = formatDate(payload, timeFormat);
    if (!(payload.getDate() === todayDate.getDate() && payload.getMonth() === todayDate.getMonth() && payload.getFullYear() === todayDate.getFullYear())) {
        formattedDate = payload.getFullYear() + "-" + prependZero(payload.getMonth() + 1) +
            "-" + prependZero(payload.getDate()) + " " + formattedDate;
    }
    return formattedDate;
}

/**
 * Format a date object to a string using the specified format.
 * @param date The date to format.
 * @param format The format to use. Default is 'h:mm A'.
 * @returns The formatted date string.
 */
const formatDate = (date: Date, format: string = DEFAULT_TIME_FORMAT) => {
	let formattedDate = "";
	try {
		const SUPPORTED_FORMATS = Object.values(TIME_FORMATS) as string[]; // Use enum values for validation

		// Ensure the format is valid; otherwise, use the default format
		if (!SUPPORTED_FORMATS.includes(format)) {
			format = DEFAULT_TIME_FORMAT;
		}

		// Handle specific cases like "HH" and "hh" to enforce 2-digit hour
		const options: Intl.DateTimeFormatOptions = {
			hour: format.includes("h") || format.includes("H") ? "numeric" : undefined,
			minute: format.includes("mm") ? "2-digit" : format.includes("m") ? "numeric" : undefined,
			second: format.includes("ss") ? "2-digit" : format.includes("s") ? "numeric" : undefined,
			hour12: format.includes("A"),
		};

		// Handle specific cases like "HH" and "hh" to enforce 2-digit hour
		if (format.includes("HH") || format.includes("hh")) {
			options.hour = "2-digit";
		}

		formattedDate = date.toLocaleString("en-US", options).replace(",", "");
	} catch (ex) {
		// if date is not valid, return current date
		date = date == null ? new Date() : date;
		formattedDate = date.toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true });
	}
	return formattedDate;
};
